import PropTypes from 'prop-types';
import React from 'react';
import Classnames from 'classnames';

require('./style.scss');

const Badge = props =>
  <div
    className={Classnames('badge', props.className)}
    style={{
      cursor: props.clickable ? 'pointer' : null,
      backgroundColor: props.backgroundColor,
      color: props.color }}
  >
    {props.leftIcon}{props.leftIcon ? ' ' : null}
    <span className="label">{props.label}</span>
    {props.leftIcon ? ' ' : null}{props.rightIcon}
  </div>;

Badge.Group = props =>
  <div className="badge-group">{props.children}</div>;

Badge.propTypes = {
  backgroundColor: PropTypes.string,
  className: PropTypes.string,
  clickable: PropTypes.bool,
  color: PropTypes.string,
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  leftIcon: PropTypes.element,
  rightIcon: PropTypes.element,
};

Badge.Group.propTypes = {
  children: PropTypes.node,
};

module.exports = Badge;



// WEBPACK FOOTER //
// ./app/components/common/badge/Badge.jsx